import { Component, Prop, Vue } from 'vue-property-decorator'
import { assign, map } from 'lodash'
import { Circuit, CircuitExercise, Exercise } from '@/interfaces'

@Component
export default class CircuitMixin extends Vue {
  @Prop({ default: '' }) circuitId!: string

  get circuit (): Circuit {
    return this.$store.state.circuits.base[this.circuitId]
  }

  get circuitExercises (): Exercise[] {
    return map(this.circuit.exercises, (circuitExercise: CircuitExercise) => {
      return assign(
        this.$store.state.exercises.base[circuitExercise.exerciseId],
        circuitExercise
      )
    })
  }
}
